var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"8","offset-md":"2","lg":"4","offset-lg":"4"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary"},[_vm._v("\n        Вход в программу\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }